import axios from "axios";

import { ApiService } from "./api";

import { authHeader } from "../_helpers";

const apiService = new ApiService();
apiService.setApiUrl("/contracts");

export const contractsService = {
  findAll,
  find,
  add,
  update,
  remove,
  findByBroker,
  addApiPlatform,
  transferContract,
};

async function add(item) {
  return apiService.add(item);
}

async function addApiPlatform(item) {
  return apiService.addApiPlatform(item);
}

async function findAll(page = 1) {
  return apiService.findAll(page);
}

async function find(id) {
  return apiService.find(id);
}

async function update(item) {
  try {
    await axios.put(
      `${apiService.getApiUrl()}/status/${item.id}`,
      item,
      authHeader()
    );
  } catch (error) {}
}

async function remove(id) {
  return apiService.remove(id);
}

async function findByBroker(id, page = 1) {
  let params = authHeader();
  params.params = { owner: `/brokers/${id}`, page: page };

  try {
    const res = await axios.get(`${apiService.apiUrl}`, params);

    if (res.status === 200) {
      return res.data;
    } else {
      throw res.data["hydra:description"];
    }
  } catch (err) {
    throw apiService.manageErrors(err);
  }
}

async function transferContract(
  contractPdf,
  clients,
  filename,
  contractFolder,
  sender
) {
  try {
    const formData = new FormData();
    formData.append("contractPdf", contractPdf);
    formData.append("clients", JSON.stringify(clients));
    formData.append("filename", JSON.stringify(filename));
    formData.append("sender", JSON.stringify(sender));
    formData.append("contract", JSON.stringify(contractFolder));

    const res = await axios.post(
      `${apiService.apiUrl}/transfer`,
      formData,
      authHeader()
    );

    return res.data;
  } catch (error) {
    throw apiService.manageErrors(error);
  }
}
